export const formatDecimalInput = (input: string): string => {
    let value = input.replace(/[^0-9.,]/g, '');

    value = value.replace(/\./g, ',');

    if (value.startsWith(',')) {
        value = '0' + value;
    }

    const firstComma = value.indexOf(',');
    if (firstComma !== -1) {
        value = value.slice(0, firstComma + 1) + value.slice(firstComma + 1).replace(/,/g, '');
    }

    value = value.replace(/^0+(\d)/, '$1');

    value = value.replace(/^0{2,}/, '0');

    return value;
};
